export default __webpack_public_path__ + "static/media/facial_2.48e5f1e8.jpg";